import React, { useEffect } from "react";
import { Container } from "@mui/material";
import SignupFormWrapper from "./SignupFormWrapper";

const SignupPage = () => {
  useEffect(() => {
    document.title = "Create Account";
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        py: { xs: 6, sm: 8 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
      <SignupFormWrapper />
    </Container>
  );
};

export default SignupPage;
